<template>
    <form>
        <ModalEdition :modalId="'modalTransfertStock'" :modalTitre="'Transfet de stocks'" ref="modalTransfertStockRef"
            @save="savetransfert()">
            <div class="form">
                <div class="form-group">
                    <label for="tansfert_stock_depart">Zone de stockage de départ</label>
                    <select v-model="transfert.sourceId" class="form-select">
                        <option v-for="stock in stocks" :value="stock.id" :key="stock.id">
                            {{ stock.zoneStockage.libelle + " : " + stock.total }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="tansfert_stock_final">Zone de stockage final</label>
                    <select v-model="transfert.destinationId" class="form-select">
                        <option v-for="stock in stocks" :value="stock.id" :key="stock.id">
                            {{ stock.zoneStockage.libelle + " : " + stock.total }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="tansfert_quantite">Quantité</label>
                    <input type="number" class="form-control" id="mouvementStock_libelle"
                        v-model="transfert.quantite" />
                </div>

                <div class="form-group">
                    <label for="tansfert_date">Date</label>
                    <input type="text" class="form-control" id="mouvementStock_date" v-model="transfert.date" />
                </div>
            </div>
        </ModalEdition>
    </form>
</template>

<script>
import Axios from '@/services/axios.service';
import ModalEdition from '../../../../components/ModalEdition.vue';


export default {
    name: 'stockTransfert',
    components: {
        ModalEdition
    },
    data() {
        return {
            stocks: [],
            transfert: {
                sourceId: 0,
                destinationId: 0,
                date: null,
                quantite: 0,
            },
        }
    },
    mounted() {
        Axios.get('/stock/statut/ACTIF').then(res => {
            this.stocks = res.data;
        })
            .catch(err => {
                console.error('Erreur lors du chargement des stocks :', err);
            });
    },
    methods: {
        savetransfert() {
            this.errors = [];
            if (!this.transfert.sourceId) {
                this.errors.push({ message: "La zone de départ est obligatoire." });
            }
            if (!this.transfert.destinationId) {
                this.errors.push({ message: "La zone de final est obligatoire." });
            }
            if (this.transfert.sourceId == this.transfert.destinationId) {
                this.errors.push({ message: "La zone de départ et La zone de final doivent être differente" });
            }
            if (!this.transfert.quantite) {
                this.errors.push({ message: "La quantite est obligatoire." });
            }
            const stockSource = this.stocks.find(item => item.id === this.transfert.sourceId);
            console.log(stockSource.total)
            console.log(this.transfert.quantite)
            if (stockSource.total < this.transfert.quantite) {
                this.errors.push({ message: "La zone de départ n'a pas assez de stock." });
            }
            if (!this.transfert.date) {
                this.errors.push({ message: "La date est obligatoire." });
            }
            if (this.errors.length) {
                this.$refs.modalTransfertStockRef.errorMessage(this.errors)
                return;
            }

            Axios.post('/mouvementStock/transfert', this.transfert)
                .then(() => {
                    this.$refs.modalTransfertStockRef.closeModal();
                    this.$emit('saved');
                })
                .catch(err => {
                    console.error('Erreur lors de la souvegarde des transferts :', err);
                });
        },

    },
}
</script>

<style>
.form {
    max-width: 300px;
    margin: 0 auto;
}

.formGroup {
    max-width: 300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
}
</style>
